import { Injectable } from '@angular/core';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';

@Injectable({
  providedIn: 'root'
})
export class UploadService {
  public aws_image_base_url = "https://d199rlhrvok6zy.cloudfront.net/"
  public awsBucketUrl: any = "http://smilessoftware-images.s3-website.ap-south-1.amazonaws.com/";
  private bucket = new S3(
    {
      accessKeyId: 'AKIAX2RIBTNXPMKICQLO',
      secretAccessKey: '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',
      region: 'ap-south-1'
    }
  );
  private bucketname = "smilessoftware-images";
  
  constructor() { }

  uploadFile(file) {
    var splitedStr = file.webkitRelativePath.split("/")
    var bucketPath = "smilessoftware-images"
    if (splitedStr.length > 0) {
      for (var i = 0; i < splitedStr.length - 1; i++) {
        bucketPath = bucketPath + "/" + splitedStr[i]
      }
    }
    const contentType = file.type;
    const params = {
      Bucket: bucketPath,
      Key: file.name,
      Body: file,
      ACL: 'public-read',
      ContentType: contentType
    };
    return this.bucket.upload(params, function (err, data) {
      if (err) {
        return err;
      }
      return data;
    }).promise();
  }

  getAllPrefix() {
    var params = {
      Bucket: this.bucketname,
      Delimiter: "/"
    };

    return this.bucket.listObjectsV2(params, function (err, data) {
      if (err) {
        console.log(err)
        return err;
      }
      return data;
    }).promise()
  }

  getFiles(prefix) {
    var params = {
      Bucket: this.bucketname,
      Delimiter: "/",
      Prefix: prefix
    };

    return this.bucket.listObjectsV2(params, function (err, data) {
      if (err) {
        console.log(err)
        return err;
      }
      return data;
    }).promise()
  }

  deleteFile(key) {
    var params = {
      Bucket: this.bucketname,
      Key: key
    };
    return this.bucket.deleteObject(params, function (err, data) {
      if (err) {
        console.log(err)
        return err;
      }
      return data;
    })
  }

  upload_pdf(pdf_file, file_path, file_name) {
    var pdf_bucket_name = "smilessoftware-pdf/" + file_path;
    // var splited_str = pdf_file.webkitRelativePath.split("/")
    // if (splited_str.length > 0) {
    //   for (var i = 0; i < splited_str.length - 1; i++) {
    //     pdf_bucket_name = pdf_bucket_name + "/" + splited_str[i]
    //   }
    // }
    const contentType = pdf_file.type;
    const params = {
      Bucket: pdf_bucket_name,
      Key: file_name,
      Body: pdf_file,
      ACL: 'public-read',
      ContentType: contentType
    };
    return this.bucket.upload(params, function (err, data) {
      console.log(data)
      if (err) {
        return err;
      }
      return data;
    }).promise();
  };

  upload_images(img_file, file_path, file_name) {
    var pdf_bucket_name = file_path;
    const contentType = img_file.type;
    const params = {
      Bucket: pdf_bucket_name,
      Key: file_name,
      Body: img_file,
      ACL: 'public-read',
      ContentType: contentType
    };
    return this.bucket.upload(params, function (err, data) {
      if (err) {
        return err;
      }
      return data;
    }).promise();
  };

}
